import { render, staticRenderFns } from "./SlimElement.vue?vue&type=template&id=c1c6933a&scoped=true"
import script from "./SlimElement.vue?vue&type=script&lang=js"
export * from "./SlimElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c6933a",
  null
  
)

export default component.exports